/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Generates the theme object for the component from the theme and provided additional information
 * @param  {Object} theme The actual theme object.
 * @return {Object} The final theme object with the overrides and component variables
 */
const generateComponentTheme = theme => {
  var _colors$contrasts, _colors$contrasts2, _colors$contrasts3, _colors$contrasts4, _colors$contrasts5;
  const colors = theme.colors,
    stacking = theme.stacking,
    typography = theme.typography,
    spacing = theme.spacing,
    borders = theme.borders;
  const componentVariables = {
    desktopFontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeMedium,
    desktopFontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    desktopFontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightNormal,
    desktopBackground: colors === null || colors === void 0 ? void 0 : (_colors$contrasts = colors.contrasts) === null || _colors$contrasts === void 0 ? void 0 : _colors$contrasts.grey100100,
    desktopBackgroundInverse: colors === null || colors === void 0 ? void 0 : (_colors$contrasts2 = colors.contrasts) === null || _colors$contrasts2 === void 0 ? void 0 : _colors$contrasts2.grey1111,
    desktopBottomBorder: 'none',
    desktopBottomBorderInverse: `${borders === null || borders === void 0 ? void 0 : borders.widthSmall} ${borders === null || borders === void 0 ? void 0 : borders.style} ${colors === null || colors === void 0 ? void 0 : (_colors$contrasts3 = colors.contrasts) === null || _colors$contrasts3 === void 0 ? void 0 : _colors$contrasts3.grey1214}`,
    desktopHeight: '4rem',
    desktopZIndex: (stacking === null || stacking === void 0 ? void 0 : stacking.topmost) - 1,
    // -1 so it is below tray/modal/popover/etc TODO find a better solution

    desktopInlinePadding: spacing.small,
    desktopBrandContainerInlineMargin: `0 ${spacing.medium}`,
    desktopMenuItemsContainerInlineMargin: `0 ${spacing.large}`,
    desktopActionItemsContainerInlineMargin: `${spacing.xSmall} 0`,
    desktopUserContainerInlineMargin: `${spacing.xSmall} 0`,
    desktopUserSeparatorGap: spacing === null || spacing === void 0 ? void 0 : spacing.xSmall,
    desktopUserSeparatorHeight: '1.5rem',
    desktopUserSeparatorWidth: borders === null || borders === void 0 ? void 0 : borders.widthSmall,
    desktopUserSeparatorColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts4 = colors.contrasts) === null || _colors$contrasts4 === void 0 ? void 0 : _colors$contrasts4.grey1214,
    desktopUserSeparatorColorInverse: colors === null || colors === void 0 ? void 0 : (_colors$contrasts5 = colors.contrasts) === null || _colors$contrasts5 === void 0 ? void 0 : _colors$contrasts5.grey1214
  };
  return {
    ...componentVariables
  };
};
export default generateComponentTheme;